<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const SmileIconComment = getIcon("SmileIconComment");
</script>

{#if typeof SmileIconComment === 'string'}
	<img src={SmileIconComment} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof SmileIconComment === 'function'}
	<svelte:component this={SmileIconComment} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
